import React from "react";
import { Search } from "lucide-react";

const TrialSearchLimitBanner = ({
  count,
  limit,
  limitReached,
  onUpgrade,
}) => (
  <div className="bg-tw-warning/10 text-tw-neutral-900 px-6 py-2 flex items-center justify-between border-b border-gray-200">
    <div className="flex items-center gap-2">
      <Search className="h-4 w-4" />
      <span className="font-medium text-sm">
        Daily Searches: {count}/{limit}
      </span>
      {limitReached && (
        <span className="text-sm opacity-75">- Limit Reached</span>
      )}
    </div>
    <button
      onClick={onUpgrade}
      className="px-3 py-1 bg-tw-neutral-900 text-white rounded text-sm hover:bg-tw-neutral-800"
    >
      Upgrade to Premium
    </button>
  </div>
);

export default TrialSearchLimitBanner;

